import { useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { postApiChunkFormData } from "../helpers/AxiosInstance";
import APIS from "../constant/Endpoint";
interface Props {
  queryKey: string[];
  setIsuploaded: React.Dispatch<React.SetStateAction<boolean>>;
}
const useUploadFileHook = (props: Props) => {
  const queryClient = useQueryClient();
  const { setIsuploaded, queryKey } = props;

  const [progress, setProgress] = useState(0);
  const uploadFile = async (file, fileId, productId, onChange) => {
    const CHUNK_SIZE = 1 * 1024 * 1024;
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    const url = `${APIS.FILE_HANDLER}chunk-upload/`;
    setIsuploaded(false);

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);
      const chunkFormData = new FormData();
      chunkFormData.append("file", chunk);
      chunkFormData.append("file_id", fileId);
      chunkFormData.append("chunk_index", chunkIndex.toString());
      chunkFormData.append("total_chunks", totalChunks.toString());
      chunkFormData.append("title", file?.name?.replace(/ /g, "_"));
      if (productId) chunkFormData.append("object_id", productId);
      chunkFormData.append("folder", "Document");
      chunkFormData.append("service", "Document Upload");

      try {
        const res = await postApiChunkFormData({
          url,
          formData: chunkFormData,
          setProgress,
          chunkIndex,
          totalChunks,
        });

        if (res.status === 201 && chunkIndex === totalChunks - 1) {
          queryClient.invalidateQueries({
            queryKey: queryKey,
            refetchType: "active",
          });
          toast.success("Uploaded Successfully");
          setIsuploaded(true);
          onChange(res?.data?.file);
        } else if (chunkIndex === totalChunks - 1) {
          toast.error("Upload failed");
          setIsuploaded(true);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  return { progress, uploadFile };
};

export default useUploadFileHook;
